import { render, staticRenderFns } from "./monthChart.vue?vue&type=template&id=b624ae54&"
import script from "./monthChart.vue?vue&type=script&lang=js&"
export * from "./monthChart.vue?vue&type=script&lang=js&"
import style0 from "./monthChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports